<template>
	<div>
    <!-- <back :title="titlename"></back> -->
		<!-- banner图 -->
		<banner></banner>
    <!-- 选择类型 -->
    <div class="ywlx">
      <p>请选择业务角色</p>
      <router-link @click.native="link(2)" to="">法人</router-link>
      <router-link @click.native="link(1)" to="">自然人</router-link>
    </div>
		<!-- 底部 -->
		<tabbar></tabbar>
	</div>

</template>

<script>
export default {
    data() {
      return {
        titlename:"元和街道第一窗口"
      };
    },
    created:function(){
      console.log(this.$store.state.openId)
    },
    methods:{
      //跳转
      link(obj){
       if(obj==1){
         this.$router.push({path:'/Service',query:{personLX:obj}})
       }
        if(obj==2){
          this.$router.push({path:'/Service',query:{personLX:obj}})
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  .ywlx{
    font-size: .3rem;
    color: #333;
    font-weight: bold;
    padding: 1.1rem .9rem;
    text-align: center;
    a{
      font-size: .34rem;
      display: block;
      color: #333;
      background: #fafafa;
      padding:.33rem 0rem;
      margin-top: .454rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/yw.vue